export const RESET_CARRIER_PICKUP_LOCATION_ISFETCHING =
  'RESET_CARRIER_PICKUP_LOCATION_ISFETCHING';
export const LIST_CARRIER_PICKUP_LOCATION_REQUEST =
  'LIST_CARRIER_PICKUP_LOCATION_REQUEST';
export const CARRIER_PICKUP_LOCATION_REQUESTING =
  'CARRIER_PICKUP_LOCATION_REQUESTING';
export const LIST_CARRIER_PICKUP_LOCATION_SUCCESS =
  'LIST_CARRIER_PICKUP_LOCATION_SUCCESS';
export const RESET_CARRIER_PICKUP_LOCATION_QUERY =
  'RESET_CARRIER_PICKUP_LOCATION_QUERY';
export const ADD_CARRIER_PICKUP_LOCATION_REQUEST =
  'ADD_CARRIER_PICKUP_LOCATION_REQUEST';
export const REMOVE_CARRIER_PICKUP_LOCATION_REQUEST =
  'REMOVE_CARRIER_PICKUP_LOCATION_REQUEST';
